// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_WKcEH","placeHolder":"index_placeHolder_AG7rK","text":"index_text_RYSVU"};